<template>
  <div class="mm-page-main" v-loading="loading">
    <div class="table-box">
      <div class="table-header mb15" style="flex-wrap:wrap">
        <div>
          <el-radio-group v-model="form.area" @change="getdata">
            <el-radio-button label="-1">全部</el-radio-button>
            <el-radio-button label="0">港幣</el-radio-button>
            <el-radio-button label="1">人民幣</el-radio-button>
            <el-radio-button label="2">外幣</el-radio-button>
          </el-radio-group>
        </div>
        <div class="mt10 mb10">
        </div>
      </div>
      <div class="table-body">
        <el-table :data="currencydata" border style="width: 100%" :header-cell-style="{background:'#fafafa'}">
          <!-- <el-table-column prop="area" label="地區" width="90">
            <template slot-scope="scope">
              <div class="phonecel">地區</div>
              {{scope.row.area==0?'香港':(scope.row.area==1?'中國':'海外')}}
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="short_name" :label="$t('货币')" >
            <template slot-scope="scope">
              <div class="img-text-box">
                <img class="currency-icon" :src="scope.row.thumb" alt="">
                <span>{{scope.row.currency_short_name}}</span>
              </div>
            </template>
          </el-table-column> -->

          <el-table-column prop="bankname" label="銀行賬號" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">銀行賬號</div>
              <div class="mm-text-right">
                <div class="img-text-box" style="padding:5px;">
                  <img class="currency-icon" :src="scope.row.thumb" style="height:30px;width:30px;">
                  <span>{{scope.row.currency_short_name}}</span>
                </div>
                <div style="padding:5px;">{{scope.row.bankinfo!=''?scope.row.bankinfo:scope.row.bankname}}</div>
                <div style="padding:5px;">{{scope.row.account_name}}</div>
                <div style="padding:5px;">{{addSpace(scope.row.account_num)}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="貨幣結餘" sortable>
            <template slot-scope="scope">
              <div class="phonecel">貨幣結餘</div>
              <div>
                <span class="mr10">{{tomoney(scope.row.money)}}</span>
                <span> {{scope.row.currency_short_name}}</span>
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="costrate" label="成本" width="90" >
            <template slot-scope="scope">
              <span>{{scope.row.costrate}}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="hkd" label="折合港幣" sortable>
            <template slot-scope="scope">
              <div class="phonecel">折合港幣</div>
              <span>{{tomoney(scope.row.hkd)}} HKD</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="income_money" label="客戶結餘(應收)">
            <template slot-scope="scope">
              <div class="phonecel">客戶結餘(應收)</div>
              <div>
                <span class="mr10">{{tomoney(scope.row.income_money)}}</span>
                <span> {{scope.row.currency_short_name}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="pay_money" label="客戶結餘(應付)">
            <template slot-scope="scope">
              <div class="phonecel">客戶結餘(應付)</div>
              <div>
                <span class="mr10">{{tomoney(scope.row.pay_money)}}</span>
                <span>{{scope.row.currency_short_name}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="surplus_money" :label="'結餘'" sortable>
            <template slot-scope="scope">
              <div class="phonecel">結餘</div>
              <div>
                <span class="mr10">{{tomoney(scope.row.surplus_money)}}</span>
                <span>{{scope.row.currency_short_name}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="surplus_hkd" :label="'折合港幣'" sortable>
            <template slot-scope="scope">
              <div class="phonecel">折合港幣</div>
              <div>
                <span class="mr10">{{tomoney(scope.row.surplus_hkd)}}</span>
                <span>HKD</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="tabletotal">
          <span>總結</span>
          <span>{{tomoney(surplus_hkd_total)}} HKD</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      surplus_hkd_total: 0.00,
      addbox: false,
      value: '',
      submitStatus: false,
      loading: true,
      form: {
        area: -1
      },
      currencydata: [
      ],
    };
  },
  methods: {
    goByUrl (routerName, id = 0) {
      this.$router.push({
        name: routerName,
        params: {
          id: id
        }
      })
    },
    getdata () {
      let area = this.form.area;
      let store_id = sessionStorage.getItem('store_id');
      let mso_id = sessionStorage.getItem('mso_id');
      this.post('/api/bank/getbalance', { store_id, area, mso_id, gettype: 1 })
        .then(response => {
          if (response.length > 0) {
            let total = 0;
            this.currencydata = response.map(item => {
              item.thumb = this.apiurl + item.currency_thumb;
              if (item.status == 0) {
                item.status = true;
              } else if (item.status == 1) {
                item.status = false;
              }
              item.account_num_format = this.addSpace(item.account_num);

              total += item.surplus_hkd;
              this.surplus_hkd_total = parseFloat(total).toFixed(2);
              return item;
            })


            // console.log(this.currencydata);
          } else {
            this.currencydata = [];
          }
          this.loading = false;
        })
        .catch(error => {
          this.currencydata = [];
          console.log(error);
          this.loading = false;
        });
    },
  },
  created () {
    this.getdata();
  }
}
</script>

<style scoped>
.mb15 {
  margin-bottom: 15px;
}
.tabletotal {
  background-color: #fafafa;
  padding: 10px;
  border: 1px solid #ebeef5;
  border-top: none;
  display: flex;
  justify-content: space-between;
}
</style>